import actionTypes from './actionTypes';
import initialState from './initialState';
import { raiseEvent } from '../../utils/callbackUtil';
import eventKeys from '../../utils/eventKeys';

export const loadConnectParams = (encodedConnectParams) => {
    let connectParams;
    try {
        connectParams = JSON.parse(atob(encodedConnectParams));
    }
    catch (e) {
        // Someone tries to enter dummy data to the address bar.
        connectParams = initialState.connectParams;
    }

    return {
        type: actionTypes.LOAD_CONNECT_PARAMS,
        payload: connectParams
    };
}

export const loadGoogleAnalyticsTracker = () => async (dispatch) => {
    return fetch('api/v1/googleanalytics/gatracker')
        .then(response => response.json())
        .then(gaTracker => {
            dispatch({
                type: actionTypes.LOAD_GA_TRACKER,
                payload: gaTracker
            });

            raiseEvent(eventKeys.GA_TRACKER_LOADED, gaTracker);
        });
};


// WEBPACK FOOTER //
// ./src/modules/configuration/actions.js